






import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {AlertMessage} from '@/interfaces';

@Component
export default class DialogAlert extends Vue {
  @Prop() private alert!: AlertMessage;
}
